import type { ISbStoryData, SbBlokData } from '@storyblok/js';

export interface GeolocationData {
	country: string;
	region: string;
	city: string;
	commuting_zone_id: string | null;
}

export interface GeolocationBlockFields extends SbBlokData {
	force_match_in_editor: boolean;
	match_fields: 'city' | 'region' | 'city_region';
	cities: string;
	regions: string;
	match_blocks: Array<ISbStoryData>;
	original_blocks: Array<ISbStoryData>;
}

export function matchList(list: string, value: string): boolean {
	if (list.length === 0) return false;

	return list
		.toLowerCase()
		.split(',')
		.map((v) => v.trim())
		.includes(decodeURIComponent(value).toLowerCase());
}

export function matchLocation(
	{
		cities,
		regions,
		match_fields
	}: Pick<GeolocationBlockFields, 'cities' | 'regions' | 'match_fields'>,
	{ city, region }: GeolocationData
): boolean {
	if (match_fields === 'city') return matchList(cities, city);

	if (match_fields === 'region') return matchList(regions, region);

	return matchList(cities, city) && matchList(regions, region);
}
